const config = {
  defaultPage: '/dashboard',
  workspace: {
    paymentInfoEnable: true,
    downloadCSVEnable: true,
    editWorkspaceEnable: true,
    addWorksapceEnable: true,
    addMemberEnable: true,
    maxMemberEditable: true,
    expiredAtEditable: true,
    statusEditable: true,
  },
}

export default config
